var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Particles',{staticStyle:{"position":"absolute, width: 100%,"},attrs:{"id":"tsparticles","options":{
          background: {
              color: {
                  value: 'transparent',
              }
          },
          fpsLimit: 30,
          interactivity: {
              detectsOn: 'canvas',
              events: {
                  onClick: {
                      enable: true,
                      mode: 'push'
                  },
                  onHover: {
                      enable: false,
                      mode: 'repulse'
                  },
                  resize: true
              },
              modes: {
                  bubble: {
                      distance: 600,
                      duration: 10,
                      opacity: 0.8,
                      size:32
                  },
                  push: {
                      quantity: 1
                  },
                  repulse: {
                      distance: 200,
                      duration: 0.4
                  }
              }
          },
          particles: {
              color: {
                  value: '#000'
              },
              links: {
                  color: '#444',
                  distance: 150,
                  enable: true,
                  opacity: .3,
                  width: .5
              },
              collisions: {
                  enable: false
              },
              move: {
                  direction: 'none',
                  enable: true,
                  outMode: 'none',
                  random: false,
                  speed: .2,
                  straight: true
              },
              number: {
                  density: {
                      enable: true,
                      value_area: 1200
                  },
                  value: 64
              },
              opacity: {
                  value: 0.25
              },
              shape: {
                  type: 'polygon',
                  options: {
                    polygon: [
                    {
                      sides: 3
                    }
                    ]
                  },
              },
              size: {
                  random: true,
                  value: 5
              }
          },
          detectRetina: false
      }}}),_c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('img',{staticClass:"my-5 mb-0 logo",attrs:{"src":require("../assets/logo.png"),"height":"128"}})]),_c('v-col',{staticClass:"mb-4",attrs:{"cols":"12"}},[_c('h1',{staticClass:"display-2 mb-1"},[_vm._v(" "+_vm._s(_vm.getAppInfo.name)+" ")]),_c('h4',{staticClass:"display-5 mb-1"},[_vm._v(" "+_vm._s(_vm.getAppInfo.fullname)+" ")])]),_c('v-col',{staticClass:"mb-4",attrs:{"cols":"12"}},[_c('v-card',{staticClass:"mx-auto",staticStyle:{"background":"rgba(230,230,230,0.5)"},attrs:{"elevation":"20","max-width":"600","loading":_vm.valid}},[_c('v-card-title',{staticClass:"pb-0"}),_c('v-card-text',{staticClass:"text--primary"},[_c('v-form',[_c('v-row',[_c('v-col',{staticClass:"ml-0",attrs:{"cols":"8"}},[_c('v-text-field',{attrs:{"rules":_vm.trackingfieldrules,"counter":40,"placeholder":"123456789","filled":"","label":"TRACKING NUMBER","required":"","hint":"Please enter Container, B/L, or Reference Number"},model:{value:(_vm.trackingID),callback:function ($$v) {_vm.trackingID=$$v},expression:"trackingID"}})],1),_c('v-col',{staticClass:"ml-0",attrs:{"cols":"4"}},[_c('v-select',{attrs:{"items":_vm.trackingNumberTypes,"placeholder":_vm.trackingNumberTypes[0],"filled":""},model:{value:(_vm.NumberType),callback:function ($$v) {_vm.NumberType=$$v},expression:"NumberType"}})],1)],1)],1),_c('v-list-item',{staticClass:"grow"},[_c('v-col',{attrs:{"cols":"3"}}),_c('v-col',{attrs:{"cols":"6"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-btn',{staticClass:"ml-2 btGradient",attrs:{"elevation":"15","dark":"","block":""},on:{"click":_vm.Practing}},[_vm._v(" Search ")])],1)],1)],1)],1)],1)],1),_c('v-col',{staticClass:"mb-1",attrs:{"cols":"12"}},[_c('h3',{staticClass:"headline font-weight-bold mb-1"},[_vm._v(" How it works? ")]),_c('p',[_vm._v(" Please enter the reference number is required to use the services, please add container, tracking, or BL Number. "),_c('br'),_vm._v(" in case of any issue please contact on "),_c('a',{attrs:{"href":"mailto:abc@absaco.com"}},[_vm._v("abc@absaco.com")]),_vm._v(" "),_c('br'),_c('span',{staticStyle:{"color":"#999","font-weight":"bolder"}},[_vm._v(" App Version "+_vm._s(_vm.getAppInfo.version)+" ")])])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }